const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);

const urlParams = new URLSearchParams(window.location.search);
const fromParam = urlParams.get('from');

if (artikeldetail && (fromParam == null || fromParam.includes("nl_"))) {
    let reader = document.querySelector("main").lastChild;
    // Check ob letztes element wirklich reader
    if (reader.classList.contains("iww-teaser-container")) {
        reader.style.display = "none";
    }
}
